export const ALLOW_VIDEO = "DISABLE_VIDEO";
export const ALLOW_AUDIO = "DISABLE_AUDIO";
export const ALLOW_SCREEN = "DISABLE_SCREEN";
export const ALLOW_ANYONE = "DISABLE_ANYONE";
export const DISABLE_CHAT = "DISABLE_CHAT";
export const DISABLE_ATTACHMENT = "DISABLE_ATTACHMENT";
export const APP_NAME = "MetaCalls";
